export class MemberPreference {
  subjectSubs: MemberPreferenceOption[] = [];
  /** 不再顯示此視窗 */
  disablePop: boolean;
}

export class MemberPreferenceOption {
  id: number;
  name: string;
  sort: number;
  total: number;
  image: string;
  isFavorite: boolean;
}
